import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { PageState } from 'app/store/models/page.model';

import { setBannerComponent } from 'app/store/actions/page.action';

@Component({
  selector: 'app-features',
  templateUrl: './features.component.html',
  styleUrls: ['./features.component.scss'],
})
export class FeaturesComponent implements OnInit {
  blocks = [
    {
      title: 'Content',
      image: '/assets/images/retail/content-animated.gif',
      text: 'Use our simple content wizard to create your emails. Use examples or create your own. Just be sure to follow the important content rules. Our rules were created by sending millions of emails and studying reply behavior, psychology and understanding which words and phrases result in positive replies and which result in negative replies. Need help? Just ask and one of our content experts will assist you.',
      type: 'image-block',
    },
    {
      title: 'Intelligence',
      image: '/assets/images/retail/intelligence-animated.gif',
      text: 'Our proprietary intelligence is proven to generate responses as high as 80%. Contacts are emailed until they reply. The time between emails starts out a little more aggressive and then the frequency backs down as the contact matures in Retreva. Our Intelligence was designed around a single goal, help our clients get more meetings with prospective customers.',
      type: 'image-block',
    },
    {
      title: 'Contacts',
      text: 'Contacts are the single most important factor to your success. The more contacts you put in the busier you will be. You can add a single contact on the fly, upload a spreadsheet, share contacts with another subscriber or ask our contact specialists for advice on finding the ideal prospects for your business. The key is to consistently add contacts all of the time. How quickly can you get to 2500 or more?',
      image: '/assets/images/retail/contacts-animation.gif',
      type: 'image-block',
    },
    {
      title: 'Reply Actions',
      text: 'When contacts reply (and they will!), choose the appropriate reply action and approve or edit the auto-generated content, send the reply and create and schedule applicable follow-up emails that go out automatically eliminating those pesky tasks. Prospects are automatically updated in the system and all history is neatly filed away with the contact.',
      image: '/assets/images/retail/response-animated.gif',
      type: 'image-block',
    },
    {
      title: 'Pipeline Management',
      text: 'Assign custom pipeline steps, keep basic notes, track sales by product type and use the won / lost toggle to easily keep track of sales opportunities.  When you close a sale, populate the value and renewal date to make sure you are reaching back out at the appropriate time.',
      image: '/assets/images/retail/pipeline-animation.gif',
      type: 'image-block',
    },
    {
      title: 'Management Features',
      text: 'View rep activity, manage reps, assign contact credits, manage contacts, track sales, run reports and keep a pulse on the overall success of your team.',
      image: '/assets/images/retail/manage-users-animation.gif',
      type: 'image-block',
    },
    {
      title: 'Reporting',
      text: 'Our reporting keeps you on track.  Have confidence that you are adding enough contacts to create activity, easily view your active pipeline and forecast and quickly take a peek at your entire team’s activity.',
      image: '/assets/images/retail/reporting-animation.gif',
      type: 'image-block',
    },
    {
      title: 'Watch our story',
      text: 'Our reporting keeps you on track.  Have confidence that you are adding enough contacts to create activity, easily view your active pipeline and forecast and quickly take a peek at your entire team’s activity.',
      url: '/assets/images/retail/reporting-animation.gif',
      type: 'video-block',
    },
  ];

  constructor(private store: Store<PageState>) {
    this.store.dispatch(setBannerComponent({ banner: 'Our Features' }));
  }

  ngOnInit() {
  }
}
